export default __webpack_public_path__ + "static/media/whatsapp.19d93073.svg";